import store from '@/store'
import { v4 as uuidv4 } from 'uuid'
import { parseUrlParams } from '@/utils/index.ts'
import { PcidType } from '@/model/PcidType'
import crypto from '@/utils/crypto'

const sensors = window.sensorsDataAnalytic201505
const url = decodeURIComponent(window.location.href)
const queryString = url.split('?')[1] || ''
const query = {}
// eslint-disable-next-line array-callback-return
queryString.split('&').map((item) => {
  const list = item.split('=')
  query[list[0]] = list[1]
})
// eslint-disable-next-line prefer-regex-literals
const reg = new RegExp('amp;', 'g')
const $query = JSON.parse(JSON.stringify(query).replace(reg, ''))
const puidObj = {}

if ($query.puid) {
  const puid = crypto.byteBase64($query.puid)
  const pudilist = puid.split(',')

  pudilist.forEach((element) => {
    const list = element.split(':') || []
    if (list.length === 2) {
      puidObj[list[0]] = list[1]
    }
  })
}

let pageUuid = uuidv4()

// const inApp = navigator.userAgent.indexOf('AllSaints_') > -1// 是否在端内
// if (inApp) {
//   // 确保 title 设置完成之后再上报
//   setTimeout(() => {
//     sensors.use('PageLoad')
//   }, 0)
//   sensors.use('PageLeave', {
//     custom_props: {}, // 自定义属性
//     heartbeat_interval_time: 1,
//     max_duration: 5 * 24 * 60 * 60,
//     isCollectUrl: function () {
//       // url 为要采集页面浏览时长的页面地址。
//       return true // 采集
//       // return false; // 不采集
//     }
//   })
// }
sensors.init({
  server_url: process.env.VUE_APP_SENSORS,
  is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  app_js_bridge: false,
  use_client_time: false,
  send_type: 'ajax',
  show_log: process.env.VUE_APP_SHOW_LOG === 'true', // false, //
  heatmap: {
    // 全埋点
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    // 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
    clickmap: 'not_collect', // 不采集
    collect_tags: {
      div: {
        max_level: 1 // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
      },
      li: true,
      img: true,
      span: true
      // ... 其他标签
    },
    // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect'
  }
})
// // $webpageLoad采集
// sensors.use(pageload, { max_duration: 120 })

sensors.setOnceProfile({ first_visit_ringback_zone_time: new Date().getTime() })

let pageList = []
let otpcid = ''
const curerntPageParams = parseUrlParams(location.href)

// oppo主题pid
if (PcidType.OppoThemes.includes(curerntPageParams.pcid)) {
  const tem = window.localStorage.getItem('themeOpid') // 一键授权授权通过后会有openid
  if (tem) {
    otpcid = tem
  }
}
// 如果拿不到值则自己生成uuid当作设备id
const appBaseInfo = window.appBaseInfo ? window.appBaseInfo : { }

sensors.registerPage({
  app_session_id: $query.app_sessionid,
  h5_session_id: uuidv4(),
  bw_channel_name: () => {
    if (window.location.href.includes('pcid=ot')) {
      return 'oppo主题'
    } else if (window.location.href.includes('pcid=om')) {
      return 'oppo音乐'
    } else if (window.location.href.includes('pcid=ad')) {
      return '信息流'
    } else if (window.location.href.includes('pcid=nb')) {
      return '努比亚'
    } else {
      return 'oppo音乐'
    }
  },
  uid: () => {
    return puidObj.uid || store.getters.selfInfo.uid
  },
  pid: () => {
    return (
      (appBaseInfo && appBaseInfo['dev-pid']) ||
      puidObj.pid ||
      store.getters.selfInfo.dev_pid ||
      $query.urlPid ||
      otpcid ||
      curerntPageParams.quickid ||
      ''
    ) // 设备id
  },
  channel_id: () => {
    return appBaseInfo['dev-channel'] || store.getters.selfInfo.dev_channel || '1001' // 渠道
  },
  event_timestamp: () => {
    return new Date().getTime()
  },
  app_version: () => {
    return appBaseInfo['dev-build-version'] || store.getters.selfInfo.dev_build_version || '' // 包名
  },
  page_view_event_id: (e) => {
    if (
      ['$pageview', '$WebPageLoad'].includes(e.event) &&
      pageList.includes('$WebPageLoad') &&
      pageList.includes('$pageview')
    ) {
      pageUuid = uuidv4()
      pageList = [e.event]
    }
    pageList.push(e.event)
    return pageUuid
  },
  record_id: () => {
    return uuidv4()
  },
  $referrer: () => {
    return window.$referrer
  },
  $manufacturer: () => {
    return appBaseInfo['dev-manufacturer'] || store.getters.selfInfo.dev_manufacturer || '' // 设备制造商
  },
  $model: () => {
    return appBaseInfo['dev-model'] || store.getters.selfInfo.dev_model || '' // 设备型号
  }
})
// // 确保 title 设置完成之后再上报
// setTimeout(() => {
//   sensors.quick('autoTrack', {
//     page_source: $query.pageSource || ''
//   })
// }, 0)
const sensors1 = {
  quick: (name, ...args) => {
    sensors.quick(name, ...args)
  },
  track: (name, ...args) => {
    sensors.track(name, ...args)
  }
}
export default sensors1
